<template>
    <n-card title="Chamados" class="p-4">
      <div class="flex justify-between mb-4">
        <n-button type="primary" @click="mostrarModalNovo">Novo Chamado</n-button>
      </div>
  
      <n-data-table
        :columns="colunas"
        :data="chamados"
        :loading="carregando"
        :scroll-x="1800"
        bordered
      />
  
      <n-modal 
        :show="abrirModalNovo" 
        :title="alteracao?`Chamado #${chamado_selecionado.cd_chamado}`:'Novo chamado'"
        preset="dialog" 
        style="width: 600px"
        @close="mostrarModalNovo"
      >
      <div class="grid grid-cols-2 gap-4">
          <n-input        v-model:value="cd_agendamento" placeholder="ID Agendamento" label="ID Agendamento" />
          <n-input        v-model:value="nm_responsavel" placeholder="Responsável" label="Responsável" />
          <n-select       v-model:value="cd_status_visita" placeholder="Status da visita" :options="status_visita" label-field="nm_status_visita" value-field="cd_status_visita" filterable />
          <n-select       v-model:value="cd_tipo_loja" placeholder="Tipo de loja" :options="tipos_loja" label-field="nm_tipo_loja" value-field="cd_tipo_loja" filterable />
          <n-select       v-model:value="cd_equipamentos" placeholder="Equipamentos utilizados" :options="equipamentos" label-field="nm_equipamentos" value-field="cd_equipamentos" filterable />
          <n-select       v-model:value="cd_beacon" placeholder="Beacon" :options="beacons" label-field="nm_qrcode" value-field="cd_beacon" filterable />
          <n-date-picker  v-show="!alteracao"  v-model:formatted-value="dt_chamado" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" clearable placeholder="Data do atendimento" label="Data do atendimento"/>
          <n-input        v-model:value="nivel_sinal" placeholder="Nível do sinal" label="Nível do sinal" />
          <n-input        v-model:value="nm_observacoes" placeholder="Observações" label="Observações" />
          <div v-show="!alteracao"></div>
          <n-upload
            :action="`https://ifood-api.cwsweb.com.br/v1/acoes/chamado/${chamado_selecionado.cd_chamado}/imagens`"
            name="instalacao"
            :headers="{
                'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwidXNlcm5hbWUiOiJtZGVjaGVjaGkiLCJpYXQiOjE3NjEwMDY3NDYsImV4cCI6MTc2MzU5ODc0Nn0.bssRPHWD7Y_J-lQXCA5EZRDWotLBwhm3rFI131IgIcw'
              }"
              :max="1"
              :show-file-list="true"
              :on-finish="onUploadFinish"
              :on-error="onUploadError"
              >
                <n-button type="default">📸 Instalação</n-button>
          </n-upload>
          <n-upload
            :action="`https://ifood-api.cwsweb.com.br/v1/acoes/chamado/${chamado_selecionado.cd_chamado}/imagens`"
            name="distancia"
            :headers="{
              'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwidXNlcm5hbWUiOiJtZGVjaGVjaGkiLCJpYXQiOjE3NjEwMDY3NDYsImV4cCI6MTc2MzU5ODc0Nn0.bssRPHWD7Y_J-lQXCA5EZRDWotLBwhm3rFI131IgIcw'
            }"
            :max="1"
            :show-file-list="true"
            :on-finish="onUploadFinish"
            :on-error="onUploadError"
            >
              <n-button type="default">📸 Distância</n-button>
          </n-upload>
        </div>
  
        <div class="flex justify-end mt-4 gap-2">
          <n-button @click="mostrarModalNovo">Cancelar</n-button>
          <n-button type="primary" @click="salvarChamado">Salvar</n-button>
        </div>
      </n-modal>

      <n-modal
        :show="abrirModalVerMais"
        :title="'Chamado #' + chamado_selecionado.cd_chamado"
        preset="dialog"
        style="width: 70%; max-width: 800px"
        @close="abrirModalVerMais = false"
      >
        <div class="modal-body">
          <section>
            <h3>Chamado</h3>
            <div class="info-grid">
              <p><strong>ID:</strong> {{ chamado_selecionado.cd_chamado }}</p>
              <p><strong>Agendamento:</strong> {{ chamado_selecionado.cd_agendamento }}</p>
              <p><strong>Data:</strong> {{ chamado_selecionado.dt_chamado_formatada }}</p>
              <p><strong>Responsável:</strong> {{ chamado_selecionado.nm_responsavel_agendamento }}</p>
              <p><strong>Status:</strong> {{ chamado_selecionado.nm_status_visita }}</p>
              <p><strong>Observações:</strong> {{ chamado_selecionado.nm_obervacoes }}</p>
            </div>
          </section>
        
          <section>
            <h3>Loja</h3>
            <div class="info-grid">
              <p><strong>Nome:</strong> {{ chamado_selecionado.nm_loja }} ({{ chamado_selecionado.nm_tipo_loja }})</p>
              <p><strong>Marca:</strong> {{ chamado_selecionado.nm_marca_loja }}</p>
              <p><strong>Endereço:</strong> {{ chamado_selecionado.nm_endereco }}</p>
              <p><strong>Cidade:</strong> {{ chamado_selecionado.nm_cidade }} - {{ chamado_selecionado.nm_estado }}</p>
              <p><strong>CEP:</strong> {{ chamado_selecionado.nm_cep }}</p>
            </div>
          </section>
        
          <section>
            <h3>Equipamentos</h3>
            <div class="info-grid">
              <p><strong>Equipamentos:</strong> {{ chamado_selecionado.nm_equipamentos }}</p>
              <p><strong>Sinal:</strong> {{ chamado_selecionado.nivel_sinal }}</p>
            </div>
          </section>
        
          <section>
            <h3>QR Code</h3>
            <p><strong>Código:</strong> {{ chamado_selecionado.nm_qrcode }}</p>
            <p><strong>UUID:</strong> {{ chamado_selecionado.nm_uuid }}</p>
          </section>
        
          <section>
            <h3>Imagens</h3>
            <div class="images">
              <img
                :src="'https://sistema.cwsweb.com.br/ifood/chamados/' + chamado_selecionado.nm_caminho_imagem_instalacao"
                alt="Instalação"
              >
              <img
                :src="'https://sistema.cwsweb.com.br/ifood/chamados/' + chamado_selecionado.nm_caminho_imagem_distancia"
                alt="Distância"
              >
            </div>
          </section>
        
          <div class="actions">
            <n-button size="small" @click="abrirModalVerMais = false">Fechar</n-button>
            <n-button size="small" type="primary" @click="salvarChamado">Salvar</n-button>
          </div>
        </div>
      </n-modal>

    </n-card>
  </template>
  
  <script>
  import { NButton, useMessage, NTag } from "naive-ui"
  import api from "@/api/api"
  import { h } from 'vue'

  export default {
    data() {
      //Chamada do VER MAIS DA GRID
      const verMais = (row) =>{
        console.log('ROW',row)
        this.chamado_selecionado = row
        this.abrirModalVerMais = true
      }
      const mostrarModalNovo = (row) => {
        this.alteracao = !this.alteracao
        this.abrirModalNovo = !this.abrirModalNovo
        if(this.alteracao){
          this.chamado_selecionado = row
          console.log(this.chamado_selecionado)
          this.cd_agendamento = this.chamado_selecionado.cd_agendamento
          this.nm_responsavel = this.chamado_selecionado.nm_responsavel_agendamento
          this.cd_status_visita = this.chamado_selecionado.cd_status_visita
          this.cd_tipo_loja = this.chamado_selecionado.cd_tipo_loja
          this.cd_equipamentos = this.chamado_selecionado.cd_equipamentos
          this.cd_beacon = this.chamado_selecionado.cd_beacon
          this.nivel_sinal = this.chamado_selecionado.nivel_sinal
          this.nm_observacoes = this.chamado_selecionado.nm_obervacoes
        }
        else{
          this.chamado_selecionado = []
          this.cd_agendamento = null
          this.nm_responsavel = null
          this.cd_status_visita = null
          this.cd_tipo_loja = null
          this.cd_equipamentos = null
          this.cd_beacon = null
          this.nivel_sinal = null
          this.nm_observacoes = null
        }
      }
      const validaType = (status) =>{
        if(status == 1) return 'info'
        else if(status == 2) return 'warning'
        else if(status == 3) return 'error'
        else if(status == 4) return 'success'
      }
      const validaFunc = (row) =>{
        if      (row.cd_status_visita == 1) mostrarModalNovo(row)
        else if (row.cd_status_visita == 2) mostrarModalNovo(row)
        else if (row.cd_status_visita == 3) verMais(row)
        else if (row.cd_status_visita == 4) verMais(row)
      }
      return {
        alteracao: false,
        chamados: [],
        carregando: false,
        abrirModalNovo: false,
        abrirModalVerMais: false,
        message: useMessage(),
        nm_motivo: "",
        nm_problema: "",
        nm_observacoes: null,
        dt_chamado: null,
        vl_visita_aprovada: "N", // padrão
        cd_tipo_agendamento: 1,  // padrão
        chamado_selecionado: [],
        cd_loja: null,
        cd_agendamento: null,
        cd_status_visita: null,
        status_visita: [],
        cd_tipo_loja: null,
        tipos_loja: [],
        cd_equipamentos: null,
        equipamentos: [],
        cd_beacon: null,
        beacons: [],
        nm_responsavel: null,
        nivel_sinal: null,
        cd_chamado: null,
        colunas: [
            { 
              title: "Status", 
              key: "actions",
              render(row){
                return h(
                  NTag,
                  {
                    strong: true,
                    tertiary: true,
                    size: 'small',
                    type: validaType(row.cd_status_visita),
                    onClick: () => validaFunc(row)
                  },
                  {default:()=> row.nm_status_visita}
                )
              }
            },
            { title: "ID do chamado", key: "cd_chamado" },
            { title: "ID do agendamento", key: "cd_agendamento" },
            { title: "Status", key: "nm_status_visita" },
            { title: "Data", key: "dt_chamado_formatada" },
            { title: "Técnico", key: "nm_tecnico" },
            { title: "Responsável", key: "nm_responsavel_agendamento" },
            { title: "Equipamentos", key: "nm_equipamentos" },
            { title: "Nível do sinal", key: "nivel_sinal" },
            { 
              title: "Ver mais", 
              key: "actions",
              render(row){
                return h(
                  NButton,
                  {
                    strong: true,
                    tertiary: true,
                    size: 'small',
                    onClick: () => verMais(row)
                  },
                  {default:()=> 'Ver mais'}
                )
              }
            },
        ]
      }
    },
    created() {
      this.carregaChamados();
    },
    computed:{
      play(row){
        this.message.error("LINHA CLICADA")
        this.message.success(row)
      },
    },
    methods: {
      mostrarModalNovo(){
        this.chamado_selecionado = []
        this.alteracao = false
        this.limpaCampos()
        this.abrirModalNovo = !this.abrirModalNovo
      },
      async carregaChamados() {
        this.carregando = true
        try {
          this.chamados       = await api.get('chamado')
          this.status_visita  = await api.get('params/status_visita')
          this.tipos_loja     = await api.get('params/tipo_loja')
          this.equipamentos   = await api.get('params/equipamentos')
          this.beacons        = await api.get('beacons')
        } catch (err) {
          console.error(err)
          this.message.error("Erro ao carregar chamados")
        } finally {
          this.carregando = false
        }
        console.log('CHAMADOS', this.chamados)
      },
      onUploadError({ file, event }) {
        this.message.error(`Erro ao enviar ${file.name}`)
        console.error('Erro:', event)
      },
      async limpaCampos(){
        this.cd_agendamento = null
        this.nm_responsavel = null
        this.cd_status_visita = null
        this.cd_tipo_loja = null
        this.cd_equipamentos = null
        this.cd_beacon = null
        this.dt_chamado = null
        this.nivel_sinal = null
      },
      //FINALIZA COM O MESMO PARÂMETRO DO CADASTRO, MAS PASSANDO O ID DO CHAMADO
      async finalizarChamado(){
        try {
          const payload = {
            cd_agendamento : this.cd_agendamento,
            nm_responsavel : this.nm_responsavel,
            cd_status_visita : this.cd_status_visita,
            cd_tipo_loja : this.cd_tipo_loja,
            cd_equipamentos : this.cd_equipamentos,
            cd_beacon : this.cd_beacon,
            dt_chamado : this.dt_chamado,
            nivel_sinal : this.nivel_sinal,
            nm_observacao: this.nm_observacoes
          }
          await api.put('chamado/web/'+this.cd_agendamento, payload)
          this.message.success("Chamado criado com sucesso")
          this.mostrarModalNovo()
          this.carregaChamados()
        } catch (err) {
          console.error(err)
          this.message.error("Erro ao salvar chamado")
        }
      },
      async salvarChamado() {
        if(this.alteracao){
          this.finalizarChamado()
          return
        }
        // Aqui você envia os dados para sua API
        try {
          const payload = {
            cd_agendamento : this.cd_agendamento,
            nm_responsavel : this.nm_responsavel,
            cd_status_visita : this.cd_status_visita,
            cd_tipo_loja : this.cd_tipo_loja,
            cd_equipamentos : this.cd_equipamentos,
            cd_beacon : this.cd_beacon,
            dt_chamado : this.dt_chamado,
            nivel_sinal : this.nivel_sinal,
            nm_observacao: this.nm_observacoes
          }
          await api.post('chamado/web', payload)
          this.message.success("Chamado criado com sucesso")
          this.mostrarModalNovo()
          this.carregaChamados()
        } catch (err) {
          console.error(err)
          this.message.error("Erro ao salvar chamado")
        }
        this.limpaCampos()
      }
    }
  }
  </script>
  
  <style scoped>
  .p-4 {
    padding: 1rem;
  }
  .grid {
    display: grid;
  }
  .grid-cols-2 {
    grid-template-columns: repeat(2, 1fr);
  }
  .gap-4 {
    gap: 1rem;
  }
  .mt-4 {
    margin-top: 1rem;
  }
  .flex {
    display: flex;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .gap-2 {
    gap: 0.5rem;
  }
  .mb-4 {
    margin-bottom: 1rem;
  }
  .modal-content {
    padding: 20px;
    border-radius: 10px;
    font-family: Arial, sans-serif;
    color: #fffefe;
  }

.modal-content h2 {
  margin-top: 0;
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
}

.section {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
}

.section h3 {
  margin-top: 0;
  color: #ffffff;
}

.qrcode-box {
  padding: 10px;
  border: 1px dashed #ccc;
  border-radius: 6px;
  display: inline-block;
}

.images .image-grid {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.images img {
  width: calc(30% - 5px);
  border-radius: 8px;
  object-fit: cover;
}

.modal-footer {
  text-align: right;
  margin-top: 20px;
}
.modal-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 0.5rem;
}

section {
  border-bottom: 1px solid #eee;
  padding-bottom: 0.75rem;
}

section:last-of-type {
  border-bottom: none;
}

h3 {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.95rem;
  margin-bottom: 0.4rem;
  font-weight: 600;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 0.3rem 1rem;
  font-size: 0.9rem;
}

.images {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.images img {
  width: 180px;
  height: 120px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #ddd;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.75rem;
}

  </style>
  